<template>
  <div class="OrderView">
      <Vente />
  </div>
</template>

<script>
import Vente from '@/components/Vente.vue'

export default {
  name: 'OrderView',
  components: {
    Vente
  }
}
</script>
